import { cva } from "class-variance-authority";

export const splitButtonVariants = cva(
  "inline-flex items-center justify-center h-11 rounded-default text-nowrap defaultTransition body-base-semibold outline-none",
  {
    defaultVariants: {
      variant: "primary",
    },
    variants: {
      variant: {
        primary: `
          shadow-card
          hover:shadow-tooltip
          active:shadow-none
          disabled:shadow-none

          bg-button/primary/background/default
          text-button/primary/label/default
          hover:bg-button/primary/background/hover
          active:bg-button/primary/background/pressed
          disabled:bg-button/primary/background/default/50
          disabled:text-button/primary/label/default
          focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-active disabled:focus-visible:ring-0
        `,
        secondary: `
          shadow-card
          hover:shadow-tooltip
          active:shadow-none
          disabled:shadow-none

          bg-button/secondary/background/default
          text-button/secondary/label/default
          border border-button/secondary/border/default
          hover:bg-button/secondary/background/hover
          hover:border-button/secondary/border/hover
          active:bg-button/secondary/background/pressed
          active:border-button/secondary/border/pressed
          disabled:text-text/disabled
          disabled:border-background/brand/opacity
          disabled:hover:bg-button/secondary/background/default
          focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-default disabled:focus-visible:ring-0
        `,
        tertiary: `
          text-button/tertiary/foreground/default
          hover:text-button/tertiary/foreground/hover
          active:text-button/tertiary/foreground/pressed
          disabled:text-text/disabled
          focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-default disabled:focus-visible:ring-0
        `,
        destructive: `
          shadow-card
          hover:shadow-tooltip
          active:shadow-none
          disabled:shadow-none

          bg-button/destructive/background/default
          text-button/destructive/label/default
          border border-button/destructive/border/default
          hover:bg-button/destructive/background/hover
          hover:border-button/destructive/border/hover
          active:bg-button/destructive/background/pressed
          active:border-button/destructive/border/pressed
          disabled:bg-background/brand/opacity
          disabled:text-text/disabled
          disabled:border-background/brand/opacity
          focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-default disabled:focus-visible:ring-0
        `,
      },
    },
  },
);
